<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState,mapGetters,mapActions } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customer Balances",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Customer Balances ",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Customer Balances",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "balance",
          sortable: true,
          label: "Balance",
        },
        {
          key: "details",
          sortable: true,
          label: "Details",
        }        
      ],

      // Value from user input for adding unit
      data: {
        name: "",
        contact: "",
      },
      // edit unit
      editdata: {
        name: "",
        balance: "",
        amount: "",
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },
      balanceError:"",

      Balances:[],
      Advances:[],
      CustomersatZero:[],

      total_balance: 0,
      total_advance: 0,
      total_atzero: 0,

      json_fields: {
        NAME: "name",
        CONTACT: "contact",
        BALANCE: "balance",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("customers", ["SaveStatus","CustomerBalances"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Balances ? this.Balances.length : 1;
    },

    rows2() {
      return this.Advances ? this.Advances.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.CustomerBalances ? this.CustomerBalances.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    CustomerBalances(newValue){
        newValue.forEach(element => {
            if(element.balance > 0){
                this.Advances.push(element);
            }else if(element.balance < 0){
                this.Balances.push(element);
            }else if(element.balance == 0){
                this.CustomersatZero.push(element);
            }
        });
    }    
  },
  methods: {
    ...mapActions({
      FetchCustomerBalances: "customers/fetchCustomerBalances",
      AddCustomer: "customers/addCustomer",
      EditCustomer: "customers/editCustomer",
      DeleteCustomer: "customers/deleteCustomer",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    BalanceDetails(id){
      this.$router.push(`/customer/balance_details/${btoa(id)}`);
    }

  },
  created() {    
    this.FetchCustomerBalances();
  },
  
  updated(){
    let total_balance = 0;
    let total_advance = 0;
      if(this.Balances){
        this.Balances.forEach((item)=>{
          total_balance = total_balance+(item.balance);
        });
        this.total_balance = total_balance;
      }
      if(this.Advances){
        this.Advances.forEach((item)=>{
          total_advance = total_advance+(item.balance);
        });
        this.total_advance = total_advance;
      }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="p-3 text-muted">
                <b-tab active class="border-0">
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Customer Balances(Debtors)</span>
                    </template>
                    <div class="row mt-4">
                    <div class="col-sm-12 col-md-4">
                        <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                            Show&nbsp;
                            <b-form-select
                                class="form-select form-select-sm"
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                            ></b-form-select
                            >&nbsp;entries
                        </label>
                        </div>
                    </div>                    

                    <div class="col-4">
                      <download-excel
                        class="btn btn-info"
                        :data="Balances"
                        :fields="json_fields"
                        :worksheet="'CUSTOMER BALANCES REPORT AS OF ' + currentdate"
                        type="csv"
                        :name="'Customerbalances_report ' + currentdate + '.xls'"
                      >
                        Export <i class="fa fa-download"></i>
                      </download-excel>
                    </div>

                    <!-- Search -->
                    <div class="col-sm-12 col-md-4">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                        >
                        <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Search..."
                                class="form-control form-control-sm ms-2"
                            ></b-form-input>
                        </label>
                        </div>
                    </div>
                    <!-- End search -->
                    </div>
                    <!-- Table -->
                    <div class="table-responsive mb-0">
                    <b-table
                        class="datatables"
                        :items="Balances?Balances:[]"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                    >
                        <template #cell(index)="data">
                        {{ data.index + 1 }}
                        </template>
                        <template #cell(balance)="data">
                          {{ thousandSeprator(-data.item.balance) }}
                        </template>
                        <template #cell(details)="data">
                          <button @click="BalanceDetails(data.item.id)" class="btn-info">View Details</button>
                        </template>
                    </b-table>
                    <div class="row">
                      <div class="col-md-4"></div> 
                      <div class="col-md-4">                     
                        <h5>Total Balances: <span class="text-danger">{{(-total_balance).toLocaleString()}}</span></h5>
                      </div>
                      <div class="col-md-4"></div>
                    </div>
                    </div>
                    <Loader  v-if="!Balances"/>
                    <div class="row">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-end"
                        >
                        <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                        </div>
                    </div>
                    </div>
                </b-tab>
                <b-tab class="border-0">
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Customer Advances(Creditors)</span>
                    </template>
                    <div class="row mt-4">
                    <div class="col-sm-12 col-md-4">
                        <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                            Show&nbsp;
                            <b-form-select
                                class="form-select form-select-sm"
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                            ></b-form-select
                            >&nbsp;entries
                        </label>
                        </div>
                    </div>

                    <div class="col-4">
                      <download-excel
                        class="btn btn-info"
                        :data="Advances"
                        :fields="json_fields"
                        :worksheet="'CUSTOMER ADVANCES REPORT FOR' + currentdate"
                        type="csv"
                        :name="'Customeradvances_report' + currentdate + '.xls'"
                      >
                        Export <i class="fa fa-download"></i>
                      </download-excel>
                    </div>

                    <!-- Search -->
                    <div class="col-sm-12 col-md-4">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                        >
                        <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Search..."
                                class="form-control form-control-sm ms-2"
                            ></b-form-input>
                        </label>
                        </div>
                    </div>
                    <!-- End search -->
                    </div>
                    <!-- Table -->
                    <div class="table-responsive mb-0">
                    <b-table
                        class="datatables"
                        :items="Advances?Advances:[]"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                    >
                        <template #cell(index)="data">
                        {{ data.index + 1 }}
                        </template>
                        <template #cell(balance)="data">
                          {{ thousandSeprator(-data.item.balance) }}
                        </template>
                        <template #cell(details)="data">
                          <button @click="BalanceDetails(data.item.id)" class="btn-info">View Details</button>
                        </template>
                    </b-table>
                    <div class="row">
                      <div class="col-md-4"></div> 
                      <div class="col-md-4">                     
                        <h5>Total Advances: <span class="text-danger">{{(-total_advance).toLocaleString()}}</span></h5>
                      </div>
                      <div class="col-md-4"></div>
                    </div>
                    </div>
                    <Loader  v-if="!Advances"/>
                    <div class="row">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-end"
                        >
                        <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows2"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                        </div>
                    </div>
                    </div>
                </b-tab>
                <b-tab class="border-0">
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Customers at Zero Balance</span>
                    </template>
                    <div class="row mt-4">
                    <div class="col-sm-12 col-md-4">
                        <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                            Show&nbsp;
                            <b-form-select
                                class="form-select form-select-sm"
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                            ></b-form-select
                            >&nbsp;entries
                        </label>
                        </div>
                    </div>

                    <div class="col-4">
                      <download-excel
                        class="btn btn-info"
                        :data="CustomersatZero"
                        :fields="json_fields"
                        :worksheet="'CUSTOMERS AT ZERO BALANCE REPORT AS OF' + currentdate"
                        type="csv"
                        :name="'Customersatzero_report' + currentdate + '.xls'"
                      >
                        Export <i class="fa fa-download"></i>
                      </download-excel>
                    </div>

                    <!-- Search -->
                    <div class="col-sm-12 col-md-4">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                        >
                        <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Search..."
                                class="form-control form-control-sm ms-2"
                            ></b-form-input>
                        </label>
                        </div>
                    </div>
                    <!-- End search -->
                    </div>
                    <!-- Table -->
                    <div class="table-responsive mb-0">
                    <b-table
                        class="datatables"
                        :items="CustomersatZero?CustomersatZero:[]"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        @filtered="onFiltered"
                    >
                        <template #cell(index)="data">
                        {{ data.index + 1 }}
                        </template>
                        <template #cell(balance)="data">
                          {{ thousandSeprator(-data.item.balance) }}
                        </template>
                        <template #cell(details)="data">
                          <button @click="BalanceDetails(data.item.id)" class="btn-info">View Details</button>
                        </template>
                    </b-table>
                    <div class="row">
                      <div class="col-md-4"></div> 
                      <div class="col-md-4">                     
                        <h5>Total: <span class="text-danger">{{total_atzero}}</span></h5>
                      </div>
                      <div class="col-md-4"></div>
                    </div>
                    </div>
                    <Loader  v-if="!CustomersatZero"/>
                    <div class="row">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-end"
                        >
                        <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows2"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                        </div>
                    </div>
                    </div>
                </b-tab>
            </b-tabs>            
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
.btn-xs {
  padding: .25rem .4rem;
  font-size: .875rem;
  line-height: .5;
  border-radius: .2rem;
}
</style>
